<app-multi-select-with-search [searchFieldHidden]="params.searchFieldHidden"
                              [dropdownOptions]="filterOptions"
                              [maxVisibleItems]="8"
                              [maxHeightPx]="gridContainerHeightPx"
                              [minWidthPx]="params.minWidthPx"
                              (selectionChange)="updateFilter()"/>
